import React from 'react'
import "../../styles/open-table.css"

const OpenTable = class extends React.Component {
    componentDidMount() {
        const formScript = document.createElement("script");
        formScript.async = true;
        formScript.src = this.props.openTable;
        const formWrapper = document.getElementById("opentable");
        formWrapper.appendChild(formScript);
    }
    render() {
        return (
            <div id="opentable" className="max-w-lg" />
        );
    }
}

export default OpenTable